import { type RefObject, useEffect, useState } from "react";

export type ScrollEdges = { left: boolean; right: boolean; headerHeight: number };

export const useScrollEdges = (container: RefObject<HTMLElement | null>, enabled: boolean): ScrollEdges => {
  const [edges, setEdges] = useState<ScrollEdges>({ left: false, right: false, headerHeight: 0 });

  useEffect(() => {
    const table = enabled ? container.current?.querySelector("table") : null;
    const scroller = table?.parentElement;
    if (!table || !scroller) return;

    const update = () => {
      const head = table.querySelector("thead");
      setEdges({
        left: scroller.scrollLeft > 1,
        right: scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft > 1,
        headerHeight: head?.offsetHeight ?? 0,
      });
    };

    update();
    scroller.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const observer = new ResizeObserver(update);
    observer.observe(scroller);
    observer.observe(table);
    return () => {
      scroller.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer.disconnect();
    };
  }, [container, enabled]);

  return edges;
};
